import { EntityDefinition } from '../types/entity-definition.interface';
import { CesTable } from '../types/table.interface';

export const tableDefinition: EntityDefinition<CesTable> = {
  entityType: 'Table',
  i18nBase: 'entities.table',
  enableFiltering: true,
  defaultSortField: 'name',
  defaultSortOrder: 1,
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'entities.table.fields.name',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'description',
        headerKey: 'entities.table.fields.description',
        sortable: true,
        filterable: true,
        class: 'min-w-[250px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'measures',
        headerKey: 'entities.table.fields.measures',
        sortable: false,
        filterable: true,
        class: 'min-w-[300px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  actionButtons: {
    parent: {
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          icon: 'more_vert',
          action: 'menu',
          tooltipKey: 'common.labels.actions',
          tooltipPosition: 'bottom',
          hasPermission: { method: 'putTableDetailResource' },
        },
      ],
    },
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.table.messages.createTitle',
      edit: () => 'entities.table.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.table.messages.addButton',
      create: () => 'entities.table.messages.addButton',
      edit: () => 'entities.table.messages.editTitleWithName',
      delete: () => 'entities.table.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.table.messages.deleteConfirm',
  },
};
